<template>
  <canvas ref="chartCanvas"></canvas>
</template>

<script>
import { Chart } from 'chart.js';

export default {
  props: {
    mode: {
      type: String,
      default: 'default',
    },
    data: {
      type: Object,
    },
    color: {
      type: Array,
      default: () => ['rgba(76, 175, 80, 1)','rgba(76, 175, 80, 0)']
    },
    chartData: {
      type: Object,
    }
  },
  mounted() {
    this.renderChart(); 
  },
  methods: {
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy(); // Destroy old chart instance if exists
      }
      let dataChart = {
        type: 'line',
        data: {
          labels: [],
          datasets: [],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            x: {
              grid: {
                display: false, 
                drawBorder: false,
              },
              ticks: {
                display: false // Hides the x-axis labels
              },
              border: {
                display: false // Hides the bottom border (x-axis border)
              }
            },
            y: {
              beginAtZero: true,
              grid: {
                display: false, // Hides the grid lines for the y-axis
                drawBorder: false,
              },
              ticks: {
                display: false // Hides the Y-axis tick values
              },
              border: {
                display: false 
              }
            }
          },
          plugins: {
            legend: {
               display: false
            },
            datalabels : {
              display: false,
            },
            labels : {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          }
        }
      }

      dataChart.data.labels = [];
      dataChart.data.datasets[0] = {
        label: "value",
        type: "line",
        data: [],
        backgroundColor: (context) => {
          let bgColor = this.color;
          if(this.data && this.data.rateType == 'plus' && this.data.rate){
              bgColor = this.color;
         }else if(this.data && this.data.rateType == 'minus' && this.data.rate){
            bgColor = [
              'rgba(239, 83, 80, 1)',
              'rgba(239, 83, 80, 0)',
            ];
          }
          if(!context.chart.chartArea){
            return;
          }
          const {ctx, chartArea : {top, bottom}} = context.chart;
          const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
          gradientBg.addColorStop(0, bgColor[0]);
          gradientBg.addColorStop(1, bgColor[1]);
          return gradientBg;
        },
        fill: true,
        borderWidth: 0,
        pointRadius: 0,
      };
      if(this.chartData){
        for (const key in this.chartData){
          let data = this.chartData[key];
          let inx = data.length - 1;
          if(data[inx].isLineChart){
            dataChart.data.datasets[0].data = data[inx].data
            dataChart.data.labels = data[inx].label;
          }
        }
      }
      this.chartInstance = new Chart(this.$refs.chartCanvas, dataChart);
    },
  },
  watch: {
    data: {
      handler() {
        this.renderChart(); 
      },
      deep: true, 
    },
    chartData: {
      handler() {
        this.renderChart(); 
      },
      deep: true, 
    },
    color: {
      handler() {
        this.renderChart(); 
      },
    },
  },
};
</script>

<style scoped>
canvas {
  width: 100%;
  height: 100%;
}
</style>